import Separator from "components/shared/Separator";
import Image from "components/shared/Image";
import { Context } from "Context";
import { useContext } from "react";
import appConfig from "config.json";
const { brands } = appConfig;

const mainClass = "syndicated-footer__promotion-disclaimer";

const PromotionDisclaimer = ({ title, subtitle, imageSrc }) => {
	const {
		config: { brand, locale, absoluteLinksFromBrand },
	} = useContext(Context);

	const updateRelativeLinks = (htmlToUpdate) => {
		if (absoluteLinksFromBrand && brands?.[brand]?.domains) {
			const domainToUse =
				brands?.[brand]?.domains[locale] ||
				brands?.[brand]?.domains.default ||
				"";
			if (domainToUse) {
				return htmlToUpdate.replaceAll('href="/', `href="${domainToUse}/`);
			}
		}

		return htmlToUpdate;
	};

	if (title || subtitle) {
		return (
			<>
				<Separator section="footer" hideInDesktop />
				<div className={mainClass}>
					{imageSrc && (
						<div className={`${mainClass}__image`}>
							<Image
								image={{
									url: imageSrc,
								}}
							/>
						</div>
					)}
					<ul className={`${mainClass}__container`}>
						{title && (
							<li
								className={`${mainClass}__container__title`}
								dangerouslySetInnerHTML={{ __html: title }}
							/>
						)}
						{subtitle && (
							<li
								className={`${mainClass}__container__subtitle`}
								dangerouslySetInnerHTML={{
									__html: updateRelativeLinks(subtitle),
								}}
							/>
						)}
					</ul>
					<Separator section="footer" hideInMobile />
				</div>
			</>
		);
	} else {
		return null;
	}
};
export default PromotionDisclaimer;
